let tokenConfig = {
    "method": "post",
    "mode": "same-origin",
    crossdomain : true,
    "headers": {
      "Authorization": "Basic MjhTb2x1dGlvbnNVQVRBUEk6QXJ4OSRSMlpZViN4VWpDcA==",
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",      
      "Accept": "application/json",
    },
    "body":"grant_type=client_credentials"
};

export default tokenConfig;


// WEBPACK FOOTER //
// ./src/StartQuote/config/tokenConfig.js